import { useTranslation } from 'next-i18next';
export const PleaseContact = () => {
  const {
    t
  } = useTranslation(['subscription']);
  return <div className="w-full rounded-[16px] rounded-t border-[#27262E14] bg-white px-[20px] py-[16px]" data-sentry-component="PleaseContact" data-sentry-source-file="PleaseContact.tsx">
      <div className="flex w-full items-center">
        <span className="text-body-1-sb font-[600] text-gray-900">
          {t('subscription:payment.waiting.paymentAmount', '결제 금액')}
        </span>
        <span className="ml-auto text-h5 font-[700] text-gray-900">
          {t('subscription:pricing.plansEnterprise.buttonContact', '도입 문의')}
        </span>
      </div>
    </div>;
};